
const PricingFAQ = () => {
  const faqs = [
    {
      question: "How does the 7-day free trial work?",
      answer: "Every tier includes a 7-day free trial. You'll be asked for card details on sign-up but you won't be charged until day 8. Cancel before then and you pay nothing. Any campaign drafts you've created stay in your Google Ads account."
    },
    {
      question: "What's founder pricing? Is it really lifetime?",
      answer: "The first 50 customers who sign up to the Solo tier get $49/month — half off — locked for life. Yes, lifetime: as long as your subscription stays active, you stay on $49 even when standard pricing changes. After 50 sign-ups the offer closes."
    },
    {
      question: "Can I change tiers later?",
      answer: "Yes — upgrade, downgrade, or cancel any time from your dashboard. Upgrades are prorated. Downgrades take effect at the next billing cycle."
    },
    {
      question: "How much do I save on annual billing?",
      answer: "Annual is two months free across every tier — roughly 17% off the monthly price. Solo $990/yr, Agency $2,490/yr, Studio $5,990/yr."
    },
    {
      question: "What's a 'brand'?",
      answer: "A brand is a business you're running ads for. Solo (1 brand) suits a founder running their own product. Agency (5 brands) suits a freelancer with a small client roster. Studio (25 brands) suits a small agency. Each brand gets its own value-prop doc and its own Google Ads (sub-)account binding."
    },
    {
      question: "Is there a free plan?",
      answer: "Not anymore. We've discontinued the free tier — it created support load without an LTV path and selected for users who weren't ready to use the product properly. The 7-day free trial gives you full access to evaluate."
    },
    {
      question: "Do you offer refunds?",
      answer: "For monthly subscriptions, we do not offer refunds for the current billing cycle. For yearly subscriptions, we may issue a pro-rated refund for the unused portion if less than 50% of the subscription period has been used. Email george@upfixe.com if you need help."
    },
    {
      question: "Is my payment information secure?",
      answer: "Yes. We use industry-standard encryption and secure payment processing through Paddle. Your card details never touch our servers."
    },
    {
      question: "Need more than 25 brands?",
      answer: "Email george@upfixe.com — we'll quote enterprise pricing. Most accounts above 25 brands are also asking for white-label or custom integrations, which we handle case by case."
    }
  ];

  return (
    <section className="py-20 px-4 bg-muted/30 border-y border-muted">
      <div className="container mx-auto max-w-4xl">
        <h2 className="text-3xl font-bold mb-12 text-center">Frequently Asked Questions</h2>
        
        <div className="grid gap-6">
          {faqs.map((faq) => (
            <div key={faq.question} className="bg-background rounded-lg p-6 shadow-sm">
              <h3 className="text-xl font-semibold mb-3">{faq.question}</h3>
              <p className="text-muted-foreground">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingFAQ;
